import {SECOND_TO_MILLISECONDS, DAY_IN_SECONDS, HOUR_IN_SECONDS} from "./constant";
import BigNumber from 'bignumber.js';
import { XOXNO_IMAGE_URL } from "data";
import egld_white_logo from 'assets/img/EGLD_white.svg';
import usdc_logo from 'assets/img/coin/usdc.png';
import usdt_logo from 'assets/img/coin/usdt.svg';
import busd_logo from 'assets/img/coin/busd.svg';
import ash_logo from 'assets/img/coin/ash.png';

export const getApr = (totalRewards: string, totalLendingAmount: string, epocStartTimestamp: number) => {
  console.log(totalRewards);
  const totalRewardsValue = BigNumber(totalRewards);
  const passedMilliseconds = Date.now() - epocStartTimestamp * SECOND_TO_MILLISECONDS ;
  const passedHours = passedMilliseconds / HOUR_IN_SECONDS / SECOND_TO_MILLISECONDS;
  return totalRewardsValue.multipliedBy(8760).dividedBy(passedHours).dividedBy(totalLendingAmount);
};

export const getApy = (apr: BigNumber) => {
  return new BigNumber(new BigNumber(1).plus(apr.dividedBy(12))).pow(12).minus(1).multipliedBy(100);
};

export const getImageUrl = (collection: string, tokenId: string) => {
  if (tokenId === 'EPUNKS-46b186-0866') {
    tokenId = 'EPUNKS-46b186-05d8';
  }
  return XOXNO_IMAGE_URL + collection + '/' + tokenId + '.avif';
};

export const getTokenImage = (tokenId: string) => {
  if (tokenId === 'EGLD') {
    return egld_white_logo;
  }

  if (tokenId.includes('-')) {
    const tokenTicker = tokenId.split('-')[0];

    if (tokenTicker === 'WEGLD') return egld_white_logo;
    if (tokenTicker === 'USDT') return usdt_logo;
    if (tokenTicker === 'USDC') return usdc_logo;
    if (tokenTicker === 'BUSD') return busd_logo;
    if (tokenTicker === 'ASH') return ash_logo;
  }
};
